import React, { lazy, Suspense } from 'react';
import { useParams, Navigate } from 'react-router-dom';

const labs = {
  minecraft: lazy(() => import('./MinecraftLab')),
  roblox: lazy(() => import('./RobloxLab')),
  'among-us': lazy(() => import('./AmongUsLab')),
  'super-mario': lazy(() => import('./SuperMarioLab')),
  'pac-man': lazy(() => import('./PacManLab')),
  tetris: lazy(() => import('./TetrisLab')),
  'angry-birds': lazy(() => import('./AngryBirdsLab')),
  snake: lazy(() => import('./SnakeLab')),
  'flappy-bird': lazy(() => import('./FlappyBirdLab')),
  'temple-run': lazy(() => import('./TempleRunLab')),
};

export default function GameLabRouter() {
  const { gameId } = useParams();
  const Lab = labs[gameId];
  if (!Lab) return <Navigate to="/labs" replace />;
  return (
    <Suspense fallback={
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
          <span className="text-muted-foreground text-sm">Loading Lab...</span>
        </div>
      </div>
    }>
      <Lab />
    </Suspense>
  );
}
